import { IonCol, IonGrid, IonRow } from "@ionic/react";
import React, { FC } from "react";
import GoogleCustomersMapV2 from "../extras/GoogleCustomersMapV2";

interface IProps {};

const AlphaInsightsStaffHome:FC<IProps> = (props) => {
    return <IonGrid >
        <IonRow className="testing" style={{height:'150px'}}>
            Overview
        </IonRow>
        <IonRow>
            <IonCol className="testing" size="9">
                <IonRow className="testing ion-justify-content-center">
                    <GoogleCustomersMapV2/>
                </IonRow>
                <IonRow className="testing" style={{height:'150px'}}>Buttons</IonRow>
            </IonCol>
            <IonCol className="testing">Activity</IonCol>
        </IonRow>
    </IonGrid>
};

export default AlphaInsightsStaffHome;